module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Also by Katie Vaz")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Don’t Worry, Eat Cake")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Make Yourself Cozy")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" copyright © 2018 by Katie Vaz. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("All rights reserved. No part of this book may be used  or reproduced in any manner whatsoever without written permission  except in the case of reprints in the context of reviews. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andrews McMeel Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("a division of Andrews McMeel Universal")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ISBN: 978-1-5248-5093-7")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Library of Congress Control Number: 2018932803")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Editor: Patty Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Art Director: Holly Swayne")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Production Editor: Dave Shaw")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Production Manager: Tamara Haus")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Digital Production: Kristen Minter")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ATTENTION: SCHOOLS AND BUSINESSES")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase  for educational, business, or sales promotional use. For information,  please e-mail the Andrews McMeel Publishing Special Sales Department: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("specialsales@amuniversal.com")])]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Dedication_background.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 l"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('a', {
    attrs: {
      "id": "hello"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "",
      "src": "image/Intro_page_background.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This book is an illustrated guide for the everyday practice of self-care. By focusing on the cozy pleasures of life, like soft blankets and the comforting scent of freshly baked bread, I believe that good feelings and contentment can be found each day. Too often “me time” is accompanied by feelings of guilt or selfishness, and it’s the first item to go on a busy day’s to-do list. I created this book to be a soothing guide that promotes the importance of “me time” and its necessity in self-care. With inspiration drawn from the Danish concept of “")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("hygge,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("” my hope is that this book encourages you to seek well-being through slowing down, creating an atmosphere of coziness, and taking genuine pleasure in the ordinary. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Some pages have simple tips and uncomplicated tasks to promote coziness for you to try, and others have prompts to encourage you to add your own content. Bits of heartwarming, inspirational sayings are sprinkled in there, too, for those days when our anxious minds are a best friend and a worst enemy at the same time. This guide is inspired by my own personal experiences with having anxiety and the tendency to greatly overthink everything, and by the self-care tips and prompts that I have found  useful in my own life. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I hope that this book will feel like a hug to your heart and be a comforting tool in helping you slow down and find  contentment through the simple act of being cozy.  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1n"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Intro_page_background.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Yoga_stretching.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Yoga_stretching1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/move.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/forest_park_walk_with_friend.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/music_kind_of_day.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/instant_cozy_town.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyle-Disabled",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/add_a_little_pretty.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/easy_houseplants.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/familiar_in_home.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/familiar_in_home1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/favorite_room.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/draw_cozy_weather.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cozy_nook.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cozy_nook1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cozy_tea_time.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/sweet_quick_breads.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/be_toasty.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/be_toasty1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cozy_saturday.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cozy_saturday1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/oatmeal.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/oatmeal1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/spices_warm_fuzzies.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/spices_warm_fuzzies1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/tea_and_scone_party.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/from_scratch.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/comfy_couch_time.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cheese_platter.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cozy_textures.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/hands_lotion.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/soothing_scents.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/belly_laugh.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/rainy_day_activity.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc0208a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MakeYourselfCozy_epub_mobi.vue
// module id = 57
// module chunks = 0